/**
 * Creating Adam — Reviews Widget
 * Drop ca-reviews.js into Shopify theme assets, then include ca-reviews.liquid
 */
;(function () {
  const SUPABASE_URL = 'https://qmpcctcciifdndizkvby.supabase.co'
  const SUPABASE_ANON_KEY =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFtcGNjdGNjaWlmZG5kaXprdmJ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg3Njc3OTAsImV4cCI6MjA5NDM0Mzc5MH0.m-1ZnTq_LTqdwR547rJYoqi-4NV8TH7mBNULwD5ebkw'
  const REVIEW_APP_URL = 'https://ca-reviews-eight.vercel.app'

  // Brand palette — matches the store's actual theme colors, not a generic default
  const INK = '#121212'
  const CREAM = '#f5f4f0'
  const BORDER = '#e5e7eb'
  const FONT = 'var(--font-body-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif)'

  async function fetchReviews(productId) {
    let url = `${SUPABASE_URL}/rest/v1/reviews?state=eq.approved&order=created_at.desc&limit=50`
    if (productId) url += `&product_id=eq.${productId}`
    const res = await fetch(url, {
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
    })
    if (!res.ok) return []
    return res.json()
  }

  function stars(rating, size = 16) {
    return Array.from({ length: 5 }, (_, i) => {
      const filled = i + 1 <= Math.round(rating)
      const color = filled ? '#f59e0b' : '#d1d5db'
      return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${color}" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`
    }).join('')
  }

  function ratingBar(label, count, total) {
    const pct = total > 0 ? Math.round((count / total) * 100) : 0
    return `
      <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">
        <span style="font-size:12px;color:#6b7280;width:40px;text-align:right;">${label}</span>
        <div style="flex:1;height:8px;background:${CREAM};border-radius:4px;overflow:hidden;">
          <div style="height:100%;width:${pct}%;background:${INK};border-radius:4px;transition:width .3s;"></div>
        </div>
        <span style="font-size:12px;color:#9ca3af;width:28px;">${count}</span>
      </div>`
  }

  function reviewCard(r) {
    const initial = (r.customer_name || '?').charAt(0).toUpperCase()
    const date = new Date(r.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    // onerror hides any image that fails to load (e.g. dead Fera CDN links) instead of showing a broken-image icon
    const photos = (r.photos || []).slice(0, 4).map(
      (url) => `<img src="${url}" onerror="this.style.display='none'" style="width:64px;height:64px;object-fit:cover;border-radius:8px;border:1px solid ${BORDER};" />`
    ).join('')
    const storeReply = r.store_reply
      ? `<div style="background:${CREAM};border:1px solid ${BORDER};border-radius:8px;padding:10px 12px;margin-top:10px;">
           <p style="margin:0 0 4px;font-size:11px;font-weight:600;color:${INK};">Creating Adam replied</p>
           <p style="margin:0;font-size:13px;color:#374151;">${r.store_reply}</p>
         </div>`
      : ''

    return `
      <div style="background:#fff;border:1px solid ${BORDER};border-radius:12px;padding:20px;margin-bottom:12px;">
        <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <div style="width:38px;height:38px;border-radius:50%;background:${CREAM};display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14px;color:${INK};flex-shrink:0;">${initial}</div>
            <div>
              <p style="margin:0;font-size:14px;font-weight:600;color:${INK};">${r.customer_name}</p>
              ${r.customer_location ? `<p style="margin:0;font-size:11px;color:#9ca3af;">${r.customer_location}</p>` : ''}
            </div>
          </div>
          <div style="display:flex;align-items:center;gap:2px;">${stars(r.rating, 14)}</div>
        </div>
        ${r.heading ? `<p style="margin:0 0 6px;font-size:14px;font-weight:600;color:${INK};">${r.heading}</p>` : ''}
        ${r.body ? `<p style="margin:0;font-size:13px;color:#4b5563;line-height:1.6;">${r.body}</p>` : ''}
        ${photos ? `<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:10px;">${photos}</div>` : ''}
        ${storeReply}
        <p style="margin:10px 0 0;font-size:11px;color:#d1d5db;">${date}</p>
      </div>`
  }

  function renderWidget(container, reviews, productId, productName) {
    const total = reviews.length
    const avg = total > 0 ? reviews.reduce((s, r) => s + Number(r.rating), 0) / total : 0
    const dist = [5, 4, 3, 2, 1].map((n) => reviews.filter((r) => Math.round(r.rating) === n).length)

    const submitUrl = `${REVIEW_APP_URL}/review/submit${productId ? `?product_id=${productId}&product_name=${encodeURIComponent(productName || '')}` : ''}`

    container.innerHTML = `
      <div style="font-family:${FONT};max-width:900px;margin:0 auto;padding:32px 16px;">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;flex-wrap:wrap;gap:12px;">
          <h2 style="margin:0;font-size:22px;font-weight:700;color:${INK};">
            ${productId && productName ? `Reviews for ${productName}` : 'Customer Reviews'}
          </h2>
          <a href="${submitUrl}" style="background:${INK};color:#fff;padding:10px 20px;border-radius:8px;font-size:13px;font-weight:600;text-decoration:none;">
            Write a Review
          </a>
        </div>

        ${total > 0 ? `
        <div style="display:flex;gap:32px;flex-wrap:wrap;margin-bottom:28px;padding:20px;background:${CREAM};border-radius:12px;border:1px solid ${BORDER};">
          <div style="text-align:center;min-width:80px;">
            <p style="margin:0;font-size:48px;font-weight:800;color:${INK};line-height:1;">${avg.toFixed(1)}</p>
            <div style="display:flex;justify-content:center;gap:2px;margin:4px 0;">${stars(avg, 18)}</div>
            <p style="margin:0;font-size:12px;color:#6b7280;">${total} review${total !== 1 ? 's' : ''}</p>
          </div>
          <div style="flex:1;min-width:160px;">
            ${[5, 4, 3, 2, 1].map((n, i) => ratingBar(`${n} ★`, dist[i], total)).join('')}
          </div>
        </div>

        <div id="ca-reviews-list">
          ${reviews.map((r) => reviewCard(r)).join('')}
        </div>
        ` : `
        <div style="text-align:center;padding:48px 24px;background:${CREAM};border-radius:12px;border:1px solid ${BORDER};">
          <p style="margin:0 0 8px;font-size:18px;font-weight:600;color:#374151;">No reviews yet</p>
          <p style="margin:0 0 20px;font-size:14px;color:#9ca3af;">Be the first to share your experience</p>
          <a href="${submitUrl}" style="background:${INK};color:#fff;padding:10px 20px;border-radius:8px;font-size:13px;font-weight:600;text-decoration:none;">
            Write a Review
          </a>
        </div>
        `}
      </div>
    `
  }

  async function init() {
    const container = document.getElementById('ca-reviews-widget')
    if (!container) return

    const productId = container.dataset.productId || null
    const productName = container.dataset.productName || null

    container.innerHTML = `<div style="text-align:center;padding:40px;color:#9ca3af;font-family:${FONT};">Loading reviews…</div>`

    try {
      const reviews = await fetchReviews(productId)
      renderWidget(container, reviews, productId, productName)
    } catch {
      container.innerHTML = `<div style="text-align:center;padding:40px;color:#9ca3af;font-family:${FONT};">Could not load reviews.</div>`
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()